<template>
  <div class="table-responsive bg-white radius">
    <div class="d-flex align-items-center hand m-4" @click="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <h4 class="ml-2 mt-2">{{ $t("dashboard.text") }}</h4>
    </div>
    <tasks class="m-4" scope="ACCOUNT"></tasks>
  </div>
</template>

<script>
import Tasks from "./tasks.vue";
export default {
  components: { Tasks },

  computed: {},
  methods: {
    goBack() {
      if (!this.currentProduct) {
        window.history.back();
        return;
      }
      this.$router.push(`/${this.currentProduct.toLowerCase()}/tasks`);
    },
  },
};
</script>
